import React from 'react';
import { connect } from 'redux-bundler-react';
import classnames from 'classnames';
import { SearchInput, SearchResultsList } from '../../application-controls';
import debounce from 'lodash/debounce';
import ClickAwayListener from '../../utils/click-away-listener';

class SearchBar extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      selectedIdx: null
    }
    this.handleChange = this.handleChange.bind(this);
    this.fireSearch = this.fireSearch.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.debouncedSearch = debounce(this.fireSearch, 200);
  }

  handleItemClick(item){
    const { doSearchSelectItem } = this.props;
    doSearchSelectItem(item);
    this.handleChange('');
  }

  handleChange(val){
    const { doSearchSetQuery } = this.props;
    this.setState({selectedIdx: null})
    doSearchSetQuery(val)
    if(val.length > 0) this.debouncedSearch();
  }

  fireSearch(){
    const { doSearchShouldFire } = this.props;
    doSearchShouldFire();
  }

  handleKeyUp(e){
    const { searchResults } = this.props;
    let { selectedIdx } = this.state;
    switch(e.keyCode){
      case 40:
        if(selectedIdx === null){
          selectedIdx = 0;
        }else if(selectedIdx < (searchResults.length -1)){
          selectedIdx++;
        }
        this.setState({
          selectedIdx: selectedIdx
        })
        break;
      case 38:
        if(selectedIdx > 0) selectedIdx--;
        this.setState({
          selectedIdx: selectedIdx
        })
        break;
      case 13:
        if(selectedIdx !== null) this.handleItemClick(searchResults[selectedIdx]);
        break;
      default:
        break;
    }
  }

  render(){
    const { selectedIdx } = this.state;
    const { theme, searchResults, searchQueryString, doDsAddFilter, doDsRemoveFilter, dsActiveFilters, dsFilters } = this.props;
    const containerClass = classnames({
      [theme]: true,
      'btn-group': true
    })
    return (
      <ClickAwayListener onClickAway={()=>this.handleChange('')}>
      <div>
        
        <div className={containerClass} style={{minWidth: '250px', position: 'relative', paddingLeft: '10px', paddingRight: '10px'}}>
          <SearchInput
            inline={true}
            onKeyUp={this.handleKeyUp}
            onUpdate={this.handleChange}
            filterString={searchQueryString}
            placeholder="Search..."
            addFilter={doDsAddFilter}
            removeFilter={doDsRemoveFilter}
            activeFilter={dsActiveFilters}
            filter={dsFilters}
          ></SearchInput>
        </div>
        
          <SearchResultsList
            ref={(el) => {this.searchResultsList = el}}
            onItemClick={this.handleItemClick}
            items={searchResults}
            selectedIdx={selectedIdx}
          />
        
        
      </div>
      </ClickAwayListener>
    )
  }
}

export default connect(
  'doSearchSelectItem', 
  'doSearchShouldFire',
  'doSearchSetQuery',
  'selectTheme',
  'selectSearchQueryString',
  'selectSearchResults',
  'doDsAddFilter',
  'doDsRemoveFilter',
  'selectDsActiveFilters',
  'selectDsFilters',
  SearchBar
);